import { expeditionHelp, settlementHelp } from '../help-rules.js';
// R217·R219·R220·R221·R222 — 안내 절(세계가 끝나면·사냥터 사다리·파티·PK 의 대가·손님 계정). 정적 프로브가 격리하므로 typeof 로 부른다
import { guestHelpLine, huntLadderHelp, partyHelp, pkCostHelp, worldEndHelp } from '../help-guide.js';
import { alignmentHelp } from '../alignment.js';
import { levelGrowthRules } from '../level-growth.js';
import { STORY_LINES, STORY_WELCOME, STORY_OFFERING } from '../story.js';
import { vaultFateText } from '../world-end-notice.js';
/** 조작과 규칙. 규칙을 바꾸면 여기도 바꾼다 — 낡은 도움말은 거짓말이다. */
import { ascendRule, CHANCE_AGE, fold, lore, muted, sec } from './common.js';
import { siegeFieldHelp } from './siege.js';
import { S, esc } from '../../core/state.js';
import { notifyState } from '../notify.js';
import { WORLD_NOTIFY_KINDS, worldNotifyState } from '../world-notify.js';
import { installMode } from '../install.js';
import { canonicalInviteOrigin } from '../domain-rollout.js';
import { audioSettings } from '../../core/sound.js';
import { GRADES, ULTIMATE_BSTONES, SHOP_MAX_GRADE, GLASS_SHOP_MAX_GRADE, RIFT_SHOP_MAX_GRADE, MAP_W, MAP_H, ZONE_KO, pkAllowed, zoneAt, RANK_KNEE } from '../../world/map.js';
import { SLOT_NAME } from '../../world/gearnames.js';
import { BJ_BANKER_STAND, BJ_CARD_MAX, BJ_STAKE_UNIT, BJ_TARGET } from '../../world/blackjack.js';
import { shopSaleSlotNames } from '../../world/gearsource.js';
import { readabilityControls } from '../readability.js';
import { ACTION_KEYS, PANEL_KEYS, keyCap, panelKeyLine } from '../../core/keymap.js';

/** 무게 단계 — `hud.js` 와 같은 말을 써야 한다. 두 화면이 다른 말을 하면 그게 낡는다 */
const TIER_KO = ['', '느림', '많이 느림', '못 움직임'];
import { PK_LAND, PK_GLOSS } from '../../world/pk.js';

/**
 * **PK 가 되는 곳을 손으로 안 적는다** — 지도에서 뽑는다.
 *
 * 여기엔 *"섬의 지상에서는 PK 가 되지 않는다. **갱도 안에서만** 사람을 벨 수 있다"*
 * 라고 적혀 있었다. **본토가 PK 로 열리면서 뒷문장이 거짓이 됐다** — 도움말이
 * 사람에게 *"본토는 안전하다"* 고 말하고 있었고, 본토는 지금 사람이 죽는 땅이다.
 *
 * 문장이 낡은 이유는 **곳 이름을 손으로 적었기 때문**이다. 그래서 `pkAllowed` 에게
 * 직접 물어본다 — 규칙이 또 바뀌어도 이 문장은 안 낡는다.
 *
 * ⚠ 한 구역 안에도 안전지대가 있다(본토 마을·전초지). 그래서 *"이 구역에 PK 가
 * 되는 자리가 있는가"* 로 가르고, 정착지 예외는 문장으로 따로 말한다.
 */
let pkZonesCache = null;
function pkZones() {
  if (pkZonesCache) return pkZonesCache;
  const pk = new Set(), safe = new Set();
  // 4타일 간격이면 420×340 에서 8천여 번이다 — 도움말을 처음 열 때 한 번만 돈다
  for (let y = 0; y < MAP_H; y += 4) {
    for (let x = 0; x < MAP_W; x += 4) {
      const z = zoneAt(x, y);
      if (!z || !ZONE_KO[z]) continue;
      (pkAllowed(x, y) ? pk : safe).add(z);
    }
  }
  for (const z of pk) safe.delete(z);
  pkZonesCache = { pk: [...pk], safe: [...safe] };
  return pkZonesCache;
}

/** 도움말의 PK 한 줄. 곳 이름도 용어도 전부 출처에서 온다 */
function pkLine() {
  const { pk, safe } = pkZones();
  const ko = (zs) => zs.map((z) => ZONE_KO[z]).join(' · ');
  return `<b class="w">${PK_LAND}</b>(${PK_GLOSS})는 <b>${ko(pk)}</b>다.<br>`
    + `<b>${ko(safe)}</b>과 <b>마을·전초지 안</b>에서는 다른 플레이어를 공격할 수 없다.`;
}

/**
 * ── **새 소식** ──
 *
 * **「처음이라면」 바로 다음**이다. 맨 위로 올릴까 했는데 아니다 —
 * 처음 온 사람에게는 *"뭘 하면 죽는가"* 가 먼저고, 새 소식은 **이미 아는 사람**의
 * 물음이다. 둘째 자리면 돌아온 사람도 스크롤 없이 본다.
 *
 * ⚠ **여기서 `markNewsRead()` 를 부르지 않는다** — 그리는 것과 읽은 것은 다르다.
 * 화면을 **실제로 연** 순간에 부른다(`panels/index.js`). 여기서 부르면
 * 검사기가 화면을 그려보기만 해도 읽은 것이 된다.
 */
/**
 * ── INVITE-R1 친구 초대 ── 사용자: "링크 초대 생성에 그 링크 타고 들어오면 둘 다에게
 * 가장 저렴한 펫을 하나 줄 수 있게 하자". 링크는 서버가 계정당 하나 발급하고,
 * 보상 성립(신규·첫 캐릭터)은 전부 서버가 판정한다. 켬끔은 콘솔 설정값.
 */
function inviteSec() {
  const link = S.inviteLink;
  const inviteOrigin = canonicalInviteOrigin();
  const body = !link
    ? '<div class="row"><button onclick="act.inviteLink()">내 초대 링크 만들기</button></div>'
      + '<div class="muted">초대 보상이 켜져 있을 때, 링크로 가입한 <b>신규 계정</b>이 첫 캐릭터를 만들면 초대한 사람과 친구가 보상을 받는다. 수령 상한에 도달한 계정은 받을 수 없다.</div>'
    : `<div class="kv"><span>내 코드</span><b>${esc(link.code)}</b></div>`
      + `<div class="row"><input id="invurl" readonly value="${esc(inviteOrigin + '/?invite=' + link.code)}">`
      + '<button onclick="act.inviteCopy()">복사</button></div>'
      + (link.enabled
        ? '<div class="muted">현재 초대 보상이 <b>켜져 있다</b>. 신규 계정이 첫 캐릭터를 만들면 수령 상한 내에서 양쪽에 보상을 준다. 초대한 사람은 다음 입장 때 대기 보상을 받는다.</div>'
        : '<div class="muted">지금은 초대 보상이 <b>꺼져 있다</b>. 링크는 사용할 수 있지만 보상은 이벤트 재개 후부터 지급한다.</div>');
  return lore('친구 초대', body + muted('보상은 <b>펫 또는 아이템</b>이며 종류·수량·수령 상한은 이벤트에 따라 달라진다. 이미 보유한 같은 펫은 중복 지급하지 않는다.'));
}

/* Q276 — 새 소식과 웹진 문은 메뉴 › 시스템 › 소식(`news-panel.js`)으로 옮겼다(메뉴 안에서 한 기능은 한 곳). */

/**
 * ── **새 세계 알림** ──
 *
 * ⚠ **버튼을 누르기 전에는 권한을 안 묻는다.** 들어오자마자 브라우저 권한 창이
 * 뜨면 절대규칙 4 가 반려하는 그 부류다.
 *
 * ⚠ **못 하는 것을 적어 둔다** — 탭을 닫으면 못 보낸다. 적어두지 않으면
 * 사람이 *"켰는데 안 왔다"* 로 읽는다.
 */
export function notifySec() {
  if (worldNotifyState().subscribed) return '';
  const st = notifyState();
  if (st === 'unsupported') return '';
  const line = {
    on: ['<b>알림이 켜져 있다.</b>', '알림 끄기', 'act.notifyOff()'],
    off: ['세계가 끝나고 <b>다음 세계가 열리면</b> 알려준다.', '알림 켜기', 'act.notifyOn()'],
    denied: ['이 브라우저에서 <b>알림이 차단됐다.</b> 주소창 옆 사이트 설정에서 알림을 허용한다.', '', ''],
  }[st];
  return sec('열린 탭 새 세계 알림',
    `<div class="row">${line[2] ? `<button onclick="${line[2]}">${line[1]}</button>` : ''}`
    + `<span class="qt">${line[0]}</span></div>`
    + muted('이 알림은 <b>게임 탭이 열려 있을 때만</b> 받을 수 있다.'));
}

/**
 * UNI-Q187 ③ — 닫힌 탭 알림 종류(새 세계·오늘의 목표·탑 주간 결과, R217 ⓓ 세계 종료 전 — 목록은 world-notify.js 한 벌). 켠 기기에서
 * 종류마다 켜고 끈다 — 기기(서비스 워커)가 보여 줄지 정하고, 서버도 같은 선택을 받아 이 기기가 숨길 종류는 아예 안 보낸다.
 */
export function worldPushSec() {
  const st = worldNotifyState();
  const kinds = st.subscribed && st.kindsReady ? WORLD_NOTIFY_KINDS.map(([kind, name, when]) => {
    const on = st.kinds[kind] !== false;
    return `<div class="item push-kind"><span class="nm">${name}<br><span class="qt">${when}</span></span>`
      + `<button class="${on ? 'on' : ''}" onclick="act.webPushKind('${kind}', ${on ? 'false' : 'true'})"${st.busy ? ' disabled' : ''}>${on ? '켜짐' : '꺼짐'}</button></div>`;
  }).join('') : '';
  return sec('닫힌 탭 알림', muted(esc(st.message)) + kinds
    + '<div class="row">'
    + (st.subscribed
      ? `<button onclick="act.webPushOff()"${st.busy ? ' disabled' : ''}>이 기기 알림 끄기</button>`
      : `<button onclick="act.webPushOn()"${!st.supported || !st.enabled || st.busy ? ' disabled' : ''}>알림 켜기</button>`)
    + `<button onclick="act.webPushRefresh()"${st.busy ? ' disabled' : ''}>상태 확인</button></div>`
    + muted('켠 기기로 새 세계·오늘의 목표·탑 주간 결과·세계 종료 전 알림을 보낸다. 받을 종류는 켠 뒤 고른다. 브라우저와 기기에서도 알림을 허용해야 한다.'));
}

export function audioSec() {
  const a = audioSettings();
  const pct = (v) => Math.round(v * 100);
  return sec('소리', `
    <div class="item audio-master"><span class="nm">전체 소리<br>
      <span class="qt">모든 소리를 한 번에 켜고 끈다</span></span>
      <button class="${a.on ? 'on' : ''}" onclick="act.audioToggle()">${a.on ? '켜짐' : '꺼짐'}</button></div>
    <label class="audio-row"><span>배경음</span>
      <input type="range" min="0" max="100" step="1" value="${pct(a.music)}"
        aria-label="배경음 음량" oninput="act.musicVol(this.value)">
      <output id="musicvol">${pct(a.music)}%</output></label>
    <label class="audio-row"><span>효과음</span>
      <input type="range" min="0" max="100" step="1" value="${pct(a.sfx)}"
        aria-label="효과음 음량" oninput="act.sfxVol(this.value)">
      <output id="sfxvol">${pct(a.sfx)}%</output></label>
    <label class="audio-row"><span>환경음</span>
      <input type="range" min="0" max="100" step="1" value="${pct(a.ambient ?? 0.5)}"
        aria-label="환경음 음량" oninput="act.ambVol(this.value)">
      <output id="ambvol">${pct(a.ambient ?? 0.5)}%</output></label>
    <div class="item audio-swell"><span class="nm">전투 음악 고조<br>
      <span class="qt">${a.swellLite ? '이 기기는 느려서 자동으로 꺼 두었다' : '싸우거나 보스 곁에 있으면 북·저음·금관이 배경음에 더해진다'}</span></span>
      <button class="${a.swell ? 'on' : ''}" onclick="act.musicSwell(${a.swell ? 'false' : 'true'})">${a.swell ? '켜짐' : '꺼짐'}</button></div>
    ${muted('효과음은 타격·몬스터·줍기·알림, 환경음은 바람·새·물방울 같은 바탕 소리다. 광고를 보거나 다른 탭으로 이동하면 소리가 멈춘다. 음량은 이 기기에 저장된다.')}`);
}

function equipmentHelp() {
  return lore('장비 획득처 · 상점과 사냥', `
    · 일반 장비 상점의 <b>완제품 판매 부위는 ${shopSaleSlotNames(SLOT_NAME).join('·')}뿐</b>이다. 다른 부위는 팔 수만 있다.<br>
    · 일반 마을은 <b>${GRADES[SHOP_MAX_GRADE].name}</b>까지, 비늘바람은 <b>${GRADES[RIFT_SHOP_MAX_GRADE].name}</b>까지, 유리샘은 <b>${GRADES[GLASS_SHOP_MAX_GRADE].name}</b>까지 해당 완제품을 판다.<br>
    · 다른 일반 장비 부위도 <b>${GRADES[SHOP_MAX_GRADE].name} 이하</b>는 <b>상점 → 갬블 → 운장수 상자깡</b> 또는 사냥으로 얻는다. 상자깡에서 그보다 높은 등급은 나오지 않는다.<br>
    · 상점이 팔지 않는 높은 등급은 <b>사냥·승급</b>으로 얻는다. 조잡한 장비, 길드 상점의 귀속 장비·반지, 악세사리는 각각 별도 상품이다.<br>
    · 자세한 획득처는 <b>도감 → 부위·등급</b>에서 확인한다.`);
}

/**
 * R229(레드팀 P2-9 ③) — 대화 문단은 이 세계의 교감 켬끔을 따라 갈린다(`S.socialOn` — 원주민 창을 한 번 열면 서버가 알려 준다).
 * 꺼진 세계에서 「말을 걸면 답한다」를 가르치면 대답 없는 원주민이 고장처럼 보인다. 모를 때는 조건을 붙여 말한다.
 * 사냥터 안에서는 채팅에 답하지 않고(R257) 「인사하기」에만 짧게 답한다 — 친밀도는 마을에서 가까이 만날 때만 오른다.
 */
function residentTalkHelp() {
  const panel = '원주민을 누르면 원주민 창에서 친밀도(하트 다섯 칸)·만난 횟수·함께 잡은 몬스터·최근 한 일을 보고 「인사하기」를 할 수 있다.';
  if (S.socialOn === false) return `<p><b>대화와 동행</b> · 이 세계에서는 원주민이 대화하지 않는다 — 「인사하기」에 짧게 답할 뿐 친밀도는 쌓이지 않고, 원주민끼리의 동행도 쉰다. ${panel}</p>`;
  const talk = '마을에서 가까이 일반 채팅으로 말을 걸거나 「인사하기」를 누르면 상황에 따라 답한다. 사냥터 안에서는 채팅에 답하지 않고 「인사하기」에만 짧게 답한다(친밀도는 마을에서 가까이 만날 때 오른다). 전체 외치기에는 답하지 않는다. 친해진 원주민끼리는 함께 이동할 수 있다.';
  if (S.socialOn === true) return `<p><b>대화와 동행</b> · ${talk} ${panel}</p>`;
  return `<p><b>대화와 동행</b> · ${talk} 대화·동행은 원주민 교감 기능이 켜진 세계에서 이용한다 — 켜졌는지는 원주민 창에 보인다. ${panel}</p>`;
}

export function render({ y }) {
  /**
   * ── **처음이라면** ──
   *
   * 길잡이 로안이 이 화면을 연다. **그 사람이 제일 먼저 볼 것이 조작키 목록이면
   * 안 된다** — 알아야 할 것은 *"뭘 하면 죽는가"* 다.
   *
   * ⚠ **내용을 지어내지 않았다.** 여섯 항목 전부 **오늘 실제로 사람이 걸린 것**이다:
   * 물약 94개로 멈춘 사람(무게) · 강화석을 낮은 단계에 쓴 사람 · 본토가 PK 인 줄
   * 몰랐던 사람 · 창고를 안 쓴 사람.
   *
   * ⚠ **수치를 손으로 안 적는다.** 안전 구간·PK 구역은 미러에서 뽑는다 —
   * 규칙이 바뀌면 이 문단이 따라온다. 오늘 도움말이 *"갱도 안에서만"* 이라고
   * **거짓말하고 있던 것**이 손으로 적어서였다.
   *
   * ⛔ 팝업이 아니다(절대규칙 4). 눌러서 여는 화면이고 언제든 닫는다.
   */
  const zs = pkZones();
  const ko = (a) => a.map((z) => ZONE_KO[z]).join(' · ');
  let h = '<p class="ux-summary">궁금한 주제를 펼쳐 본다. 규칙을 읽다가 바로 관련 화면으로 갈 수 있다.</p>'
    + sec('지금 막힌 일이 있다면', '<div class="ux-actions"><button onclick="act.openPanel(\'inv\')">무거운 가방 정리하기</button><button onclick="act.openPanel(\'realty\')">귀환 목적지 바꾸기</button><button onclick="act.openPanel(\'settings\')">화면·소리 조절하기</button><button onclick="act.openPanel(\'account\')">캐릭터 기록 보관하기</button></div>');
  h += '<details class="ux-details" id="help-start"><summary>처음 왔다 · 세계와 기본 조작</summary>';
  // Q276 — 핵심 안내는 한 줄씩. 긴 규칙은 [자세히] 안에 그대로 둔다
  h += sec('핵심 안내', `<div class="help-quick">
    <p>바닥을 눌러 이동하고 몬스터를 눌러 공격한다.</p>
    <p>늘 보이는 다섯 칸 — <b>가방 · 스킬 · 지도 · 행사 · 메뉴</b>. 나머지는 <b>메뉴</b> 한 화면에 묶였다.</p>
    <p>무거우면 느려진다. 잡화상에 팔거나 창고에 맡긴다.</p>
    ${fold('죽으면 잃는다 — 귀중품은 창고에 맡긴다',
    `죽으면 은화·아이템·경험치를 잃을 수 있다(Lv5 전에는 잃지 않는다). 귀중품은 창고에 맡긴다 — 창고는 죽어도 남는다. <b>${vaultFateText(S.you)}.</b>`)}
    ${fold('세계는 남은 시간이 다 되면 끝난다',
    `세계는 좌상단의 남은 시간이 다 되면 끝난다. 끝나면 레벨·가방은 초기화된다. ${vaultFateText(S.you)}. 집·도감·길드는 남고 새 세계 보상은 지급 조건에 따른다 — 아래 「세계가 끝나면」.`)}
    ${fold('처음엔 미니맵 아래 「다음 목표」를 따라간다',
    '처음 들어오면 물약 20개와 무기를 바로 받는다. 미니맵 아래의 <b>다음 목표</b>를 따라가면 Lv10 까지 길을 안내하고(누르면 방향과 걸음 수), 목표를 채우면 <b>보상 받기</b>로 물약·강화석을 받는다(설정에서 숨길 수 있다).')}
    ${fold('Lv10부터 같은 자리에 「오늘의 목표」가 뜬다',
    'Lv10 부터는 같은 자리에 <b>오늘의 목표</b>가 뜬다 — 내 레벨대 몬스터 사냥, 보스·네임드 처치, 시련의 탑 층 통과(Lv50 부터). 채울 때마다 강화석, 모두 채우면 축복받은 강화석을 받는다. 계정당 하루 한 번이고 한국 시간 자정에 새로 시작한다. 파티원·원주민과 같이 잡아도 인정된다.')}
    </div>`);
  h += lore('이 세계의 이야기', `<div class="story-help"><p>${STORY_LINES.map(esc).join('\n')}</p>
    <p class="story-native">“${esc(STORY_WELCOME)}”<br>${esc(STORY_OFFERING)}</p>
    <button type="button" data-story-replay>도착 장면 다시 보기</button></div>`);
  h += lore('처음이라면 · 자세한 안내', `
    <div class="kv"><span>① 무게</span><b>무게 한도를 넘으면 이동이 느려진다</b></div>
    <div class="muted">가진 것이 무거우면 <b>${TIER_KO.filter(Boolean).join(' → ')}</b>.
      잡화상에 팔거나 창고에 맡긴다. 사냥터에서 무거워 못 움직이면 가방에서 <b>버리거나</b>(바닥에 둔다 — 누구나 주울 수 있다) <b>귀환(${keyCap(ACTION_KEYS.scroll)})</b>해 마을에서 팔거나 맡긴다.</div>
    <div class="kv"><span>② 강화</span><b>등급마다 안전수치가 다르다</b></div>
    <div class="muted">${GRADES.map((g) => `${g.name} +${g.safe}`).join(' · ')}.<br>
      안전수치까지는 은화로 확정 강화한다. 그 위에서는 강화석을 쓰며 성공 확률이 적용된다. 궁극은 +0부터 강화석을 쓴다.
      실패해도 <b>장비는 안 부서지고</b> 시도에 쓴 강화석만 사라진다.</div>
    <div class="kv"><span>③ ${PK_LAND}</span><b class="w">${ko(zs.pk)}</b></div>
    <div class="muted"><b>${ko(zs.safe)}</b>에서는 PK가 불가능하다.
      PK 가능 지역에서도 <b>마을·전초지 안</b>은 안전하다.
      그 밖에서는 <b class="w">다른 사람에게 공격받고 전리품을 빼앗길 수 있다.</b></div>
    <div class="kv"><span>④ 잃는 것과 지키는 것</span><b>창고는 죽어도 남는다 · ${vaultFateText(S.you)}</b></div>
    <div class="muted">죽으면 보호 품목을 제외한 소지품이 바닥에 떨어질 수 있고 <b>누구든 주울 수 있다</b>.
      다른 사람이 줍거나 사라지기 전에 돌아가면 회수할 수 있다.
      창고에 맡긴 것은 죽어도 남는다. <b>${vaultFateText(S.you)}.</b> 새 세계 보상은 지급 조건에 따라 창고에 더해진다(아래 「세계가 끝나면」).</div>
    <div class="kv"><span>⑤ 돌아오는 길</span><b>귀환 주문서 (R)</b></div>
    <div class="muted">물약상인이 판다. 기본 시전 4초이며 펫 효과로 짧아질 수 있다. <b>이동하거나 맞으면 끊긴다.</b></div>
    <div class="kv"><span>⑥ 거래</span><b>마을에서 상대를 누르면 이름표 카드 → [거래 신청]</b></div>
    <div class="muted">마을에서 가까운 상대에게 거래를 신청한다(메뉴 › 사람 › 거래의 가까운 사람 목록에서도 된다). 양쪽이 모두 확정하면 물품과 은화가 교환된다. 자세한 제한은 아래 거래 안내를 본다.</div>
    ${typeof partyHelp === 'function' ? partyHelp() : ''}`);

  h += lore('조작 · 단축키', `
    <div class="kv"><span>이동</span><b>바닥 클릭 · 끌면 계속</b></div>
    <div class="kv"><span>공격</span><b>몬스터 클릭</b></div>
    <div class="kv"><span>자동 공격</span><b>사거리 안 몬스터를 반복 공격 · 없으면 근처 몬스터로 걸어가 친다</b></div>
    <div class="muted">표적이 죽으면 자동 공격이 꺼져 있어도 나를 친 몬스터, 그다음 사거리 안 가장 가까운 몬스터로 이어 친다. 내가 직접 걷거나 몬스터를 누르면 그쪽이 먼저다.</div>
    <div class="kv"><span>자동 반격</span><b>기본 꺼짐 · 설정(O) 또는 가방 → 물품 → 자동 동작에서 선택</b></div>
    <div class="muted">자동 반격을 켜면 나를 공격한 몬스터·경비병·플레이어를 최대 9초·12타일까지 추격한다. 꺼 두면 멀리서 친 상대를 따라가지 않는다 — 자동 공격이 켜져 있으면 근처 몬스터(나를 친 몬스터 먼저)로는 걸어간다. 직접 선택한 대상은 이 설정과 관계없이 공격한다.</div>
    <div class="kv"><span>스킬</span><b>1 · 2 · 3 · 4 · 5 · 6</b></div>
    <div class="kv"><span>스킬 강화·패시브</span><b>[스킬] 칸 (${keyCap(PANEL_KEYS.skills)})</b></div>
    <div class="kv"><span>강제 공격</span><b>Ctrl(Shift) + 클릭 · ${keyCap(ACTION_KEYS.force)} 키로 고정 · 휴대폰은 [자동] 버튼 위 창의 [강공] · 마을·전초지에 들어오면 꺼진다</b></div>
    <div class="kv"><span>사람에게 거래·파티</span><b>마을·전초지에서 사람을 누르면 이름표 카드</b></div>
    <div class="kv"><span>채팅</span><b>Enter · 화면 아래 [기록] → [말하기]</b></div>
    <div class="kv"><span>전체에 외치기</span><b>! 로 시작해서 말한다</b></div>
    <div class="kv"><span>파티 만들기</span><b>메뉴 › 사람 › 파티 · 이름표 카드의 [파티 초대]</b></div>
    <div class="kv"><span>파티에게 말하기</span><b>/p 로 시작해서 말한다</b></div>
    <div class="kv"><span>길드에게 말하기</span><b>/g 로 시작해서 말한다</b></div>
    <div class="kv"><span>귓말</span><b>/w 이름 할 말 — 그 사람에게만</b></div>
    <div class="kv"><span>차단</span><b>/block 이름 · 풀기 /unblock 이름 · 목록 /block</b></div>
    <div class="muted">길드 채팅은 같은 길드에서 지금 접속 중인 사람에게, 귓말은 접속 중인 그 사람 한 명에게만 간다 — 마을·사냥터 어디서든. 상대가 접속해 있지 않거나 없는 이름이면 그렇다고 알려 준다. 원주민에게는 귓말이 닿지 않는다. 차단한 사람(같은 계정의 모든 캐릭터)의 귓말과 채팅은 길드 채팅 말고는 보이지 않는다 — 사람을 눌러 뜨는 이름표 카드의 [차단]도 같다.</div>
    <div class="kv"><span>지도</span><b>${keyCap(ACTION_KEYS.map)} · 미니맵을 눌러도 열린다</b></div>
    <div class="kv"><span>소리 켜기/끄기</span><b>메뉴 › 시스템 › 설정의 소리</b></div>
    <div class="kv"><span>대상 바꾸기</span><b>다른 대상 클릭 · 터치</b></div>
    <div class="kv"><span>대상 해제</span><b>우클릭 · Esc</b></div>
    <div class="kv"><span>시야 멀리 / 가까이</span><b>마우스 휠 · − / = (휴대폰·태블릿은 [시야])</b></div>
    <div class="kv"><span>줍기</span><b>밟으면 자동</b></div>
    <div class="kv"><span>물약 / 귀환</span><b>${keyCap(ACTION_KEYS.potion)} / ${keyCap(ACTION_KEYS.scroll)}</b></div>
    <div class="kv"><span>창 열기</span><b>${panelKeyLine()}</b></div>
    <div class="muted">키를 꾹 누르고 있어도 한 번만 일어난다 — 물약·스킬이 연달아 나가지 않는다.</div>`);

  h += '</details><details class="ux-details" id="help-gear"><summary>더 강해지고 싶다 · 장비 획득·강화·승급</summary><div class="ux-actions"><button onclick="act.openPanel(\'inv\')">내 장비 살펴보기</button><button onclick="act.openPanel(\'skills\')">스킬 살펴보기</button></div>';
  h += lore('장비 강화와 승급', `
    장비를 강화하고, 더 높은 등급으로 승급한다.<br>
    · <b>+0 → 안전수치까지 은화</b>로 확정 강화된다.<br>
    · 안전수치를 넘으면 <b>머지</b>(같은 부위·등급·강화 수치·축복 상태인 장비 두 개를 합쳐 +1, 100%),
      <b>강화석</b>(확률, <b>실패해도 파괴 없음</b>),
      <b>축복받은 강화석</b>(강화석과 같은 확률·성공하면 1~3단계, 보스 드롭).<br>
    · <b>승급</b> — ${ascendRule()}<br>
    · <b>일반 드롭 장비 6부위</b>(무기·갑옷·투구·장갑·신발·망토)를 강화·승급할 수 있다. 가방은 강화할 수 없다.<br>
    · <b>반지도 궁극까지 승급</b>할 수 있다. 길드 귀속 반지는 같은 계정의 같은 상품끼리, 서약의 반지는 서약의 반지끼리 합친다. 반지 외의 길드 귀속 장비는 합성 재료로 쓸 수 없다.<br>
    · 마지막 <b>궁극</b>은 +10 이후 <b>1%·축복받은 강화석 ${ULTIMATE_BSTONES}개</b>로 제한 없이 오른다.
      성공하면 <b>1~3단계</b>. 행운·광고 배수도 이 확률을 바꾸지 않는다.<br>
    · 승급하면 +0으로 돌아가며 <b>성능은 이전 등급의 +10보다 높다.</b>`);

  h += equipmentHelp();

  h += '</details><details class="ux-details" id="help-risk"><summary>위험과 손실이 궁금하다 · 사망·PK·세계 종료</summary>';
  h += lore('사망 · 손실과 보호', `
    · <b>Lv5 전에는 죽어도 아무것도 잃지 않는다</b>(떨어뜨림·사망 공지 없음). 익히는 동안의 보호다.<br>
    · Lv5부터 사망 시 <b>현재 쌓인 경험치의 5%</b>를 잃는다. 레벨 자체가 내려가지는 않는다.<br>
    · 보호 예외가 없으면 일반 재료는 <b>전량</b>, 지갑 은화는 <b>50%</b>를 흘린다.<br>
    · 선3의 성향 보호가 적용되면 착용·가방 장비를 모두 지킨다. 그 밖에는 착용 장비 각각 <b>12%</b>, 가방의 미착용 장비 각각 <b>35%</b> 확률로 떨어진다.<br>
    · 패시브 서적·유물 날개·스킬 각인과 길드 귀속 장비는 사망 드롭에서 보호된다.<br>
    · 소모품과 배운 스탯·스킬·패시브는 일반 사망 드롭으로 사라지지 않는다. 데리고 있던 펫은 함께 쓰러진다. 창고 은화로 자동 부활하며, 은화가 부족하면 펫 메뉴에서 되살린다. 조련사에서 같은 펫을 합쳐 올린 강화 단계는 부활해도 남는다.<br>
    · 착용 중인 수호·불사조 날개가 재사용 조건에 따라 죽음을 막을 수 있다. 무결의 날개는 드롭만 보호하며 경험치 손실·부활 대기는 남는다.<br>
    · 떨어진 것은 <b>누구든 주울 수 있으며 5분 뒤 사라진다.</b> 사망 안내에서 실제 손실을 확인한다.<br>
    · 사망 화면에 복구·부활 지원 버튼이 표시되면 이용할 수 있다. 다른 사람이 주운 물건은 복구할 수 없다.<br>
    · <b>계정 창고는 사망 손실이 없다.</b> ${vaultFateText(S.you)}. 바로 아래 「세계가 끝나면」에서 확인할 수 있다.`);
  // R217 — 잃는 규칙 둘(죽으면·세계가 끝나면)을 붙여 둔다. 전에는 표가 원정 절 맨 뒤에만 있었다
  h += typeof worldEndHelp === 'function' ? worldEndHelp() : '';

  h += lore('성향치 · 선3 장비 보호', alignmentHelp(S.you?.alignment));

  // R227 — 강공은 공격 하나만 뜻한다(거래는 이름표 카드로 떼어 냈다) · 안전한 땅에서 꺼진다 · 강공 중에도 마을 NPC 는 눌린다
  h += lore('강제 공격 · PK', `
    <b class="w">Ctrl(또는 Shift) + 클릭</b> — 다른 <b>플레이어</b>를 때린다.
    <b>[자동]</b> 버튼 위 창의 <b>강공</b>(단축키 <b>A</b>)을 켜두면 Ctrl 없이도 클릭이 곧 공격이 된다.<br>
    · 강공은 <b>마을·전초지·내 길드 영지에 들어오면 저절로 꺼진다.</b> 켠 채로 그 땅을 나가면 기록창에 「강공 켜짐」 한 줄이 뜬다.<br>
    · 마을·전초지 안에서는 PK 가 없다 — 거기서 사람을 누르면(강공이어도) 공격 대신 <b>이름표 카드</b>(거래·파티)가 뜨고, 강공을 켜 둔 채로도 상인·게시판은 누를 수 있다.<br><br>
    ${pkLine()}`);
  // R221 — 누구를 치면 무엇이 따라오는지(💀·경비병·원주민·성향·현상금·면죄부)를 한 절에
  h += typeof pkCostHelp === 'function' ? pkCostHelp() : '';

  h += '</details><details class="ux-details" id="help-explore"><summary>어디로 갈까 · 사냥터·성장·마을 생활</summary>';
  h += lore('세상과 성장', `
    · 먼 지역일수록 강한 몬스터가 나온다. 어느 사냥터가 몇 레벨인지·어디서 가는지는 바로 아래 「사냥터 사다리」에 있다.<br>
    · 지역마다 정예 몬스터와 보스가 있다. 받는 피해를 확인하며 도전한다.<br>
    · 해안절벽 북쪽의 <b>갱도 입구</b>(텔레포터 정류장 「갱도 입구」)로 들어가면 <b>갱도</b>가 나온다.
      거기엔 <b>무법자</b>(사람 모습의 적)가 좋은 장비를 들고 떠돈다.<br>
    · <b>갱도에서는 다른 플레이어에게 공격받을 수 있다.</b><br>
    · 레벨 상한은 없다. Lv50까지 레벨업마다 스탯 3점, <b>50→51부터 4점</b>을 받는다. <b>가방 → 능력</b>에서 남은 포인트를 배분한다.<br>
    · ${levelGrowthRules()} 플레이어와 원주민에게 같은 규칙을 적용한다. <b>가방 → 능력</b>에서 현재 보너스를 확인한다.<br>
    · 액티브 스킬과 레벨 패시브는 요구 레벨에 자동으로 배운다. <b>5레벨마다 스킬 포인트 1점</b>을 받으며, 1점마다 액티브·레벨 패시브를 +1 강화한다 — <b>+100이 최대</b>다(+${RANK_KNEE}까지 단계마다 +8%, 그 위는 +100에서 본래 효과 +300%에 닿게 고르게).<br>
    · 드롭 패시브는 같은 서적을, 스킬 각인은 같은 각인석을 쓸 때마다 한 단계씩 오르며 <b>Lv${RANK_KNEE}이 최대</b>다(최대에서는 책·각인석이 남는다). 받는 피해·재사용 대기·상대 감속은 합쳐 70%, 스킬 이동·회피는 +50%가 끝이다. <b>스킬</b> 탭에서 현재·다음 효과와 재료를 확인한다.<br>
    · 전투가 끝나고 잠시 있으면 체력이 천천히 찬다. 마을에서는 훨씬 빠르다.<br>
    · 유리샘 마을 뱅커의 <b>블랙잭</b> — 무늬 없는 숫자 카드 1~${BJ_CARD_MAX}, 합이 ${BJ_TARGET}점보다 크면 버스트, 뱅커는 ${BJ_BANKER_STAND}점 이상에서 멈춘다.
      판돈은 ${BJ_STAKE_UNIT.toLocaleString()} 은화 단위(상한 없음), 배당은 잭팟 재원에서 창고로 들어간다.<br>
    · 마을 <b>슬라임 경주</b>에 은화를 걸 수 있다. 게임 안의 은화이고,
      <b>현실 돈으로는 바꿀 수 없다.</b><br>
    · 슬롯머신·블랙잭·복권·슬라임 경주·운장수 상자깡은 <b>만 ${CHANCE_AGE}세 이상</b>만 이용해 달라 — 게임 속 은화로만 하는 확률 오락이다.`);
  // R219 — 다음 사냥터를 고르는 표(지도가 없고 권장 레벨은 들어선 뒤에만 보였다)
  h += typeof huntLadderHelp === 'function' ? huntLadderHelp(zs) : '';
  // 정적 도움말 프로브는 외부 규칙 헬퍼를 격리하므로 실제 화면에서만 절을 렌더한다.
  h += typeof settlementHelp === 'function' ? settlementHelp() : '';
  h += '</details><details class="ux-details" id="help-people"><summary>함께하고 싶다 · 거래·원주민·친구 초대</summary><div class="ux-actions"><button onclick="act.openPanel(\'party\')">파티 살펴보기</button><button onclick="act.openPanel(\'trade\')">거래 살펴보기</button><button onclick="act.openPanel(\'guild\')">길드 살펴보기</button></div>';
  h += lore('거래 · 무엇을 주고받을 수 있나', `
    · 양쪽 모두 <b>마을 안, 6타일 이내</b>에 있어야 한다. 전초지는 거래 마을에 포함되지 않는다.<br>
    · 지갑 은화·재료·소모품·미착용 일반 장비를 올린다. <b>착용 장비는 먼저 벗어야</b> 하며 한 번에 장비 8점까지다.<br>
    · 길드 귀속 장비·펫·악세사리는 일반 거래 목록에 올릴 수 없다. 거래 은화는 창고에서 자동으로 보충되지 않는다 — 상점·강화·시련의 탑과 달리 서로 본 액수가 확정 순간 가방에서 그대로 오가야 하기 때문이다(필요하면 창고에서 먼저 꺼내 둔다).<br>
    · 마을에서 사람을 누르면 이름표 카드가 뜬다 — <b>[거래 신청]</b>으로 요청한다(강공·Ctrl+클릭은 공격 몸짓이라 거래를 보내지 않는다).<br>
    · 제안이 바뀌면 <b>양쪽 확정이 풀린다</b>. 멀어지거나 사망·접속 종료 시 취소되고, 교환 뒤 들 수 있는 무게를 넘으면 확정되지 않는다.<br>
    · 양쪽 저장이 확인된 뒤 거래가 끝난다. 저장 확인 중에는 같은 거래를 다시 실행하지 않는다.<br>
    · 살 사람·팔 사람을 찾을 때는 마을 게시판 <b>「사고팔기」</b> 탭에 팝니다·삽니다 글을 남기고 <b>귓말(/w 이름)</b>로 연락한다. 글에 물건·은화가 묶이지 않는다 — 주고받는 것은 만나서 이 거래 창으로 한다.`);
  h += lore('원주민 · 이 세계에서 태어난 주민', `
    <p>원주민은 이 세계에서 태어난 주민이다. 사냥으로 돈과 장비를 모으고 마을에서 정비한다. 위험하면 후퇴하고, 성장하면 다른 사냥터로 이동한다.</p>
    ${residentTalkHelp()}
    <p><b>물품 교환</b> · 원주민끼리 물약·강화석을 은화로 거래한다. 원주민 교감과 물품 교환이 모두 켜져 있어야 한다. <b>플레이어는 마을에서 원주민을 선택하고, 제안된 물품과 은화를 확인한 뒤 수락하면 교환할 수 있다.</b></p>
    <p><b>마을 생활</b> · 참여가 허용된 세계에서는 원주민도 복권·슬라임 경주에 참여한다. 생활비를 남기고 여유 자금 일부만 건다.</p>
    <p><b>접속자가 없을 때</b> · 무인 활동이 켜진 세계에서는 원주민이 계속 활동한다. 꺼져 있으면 마지막 접속자가 떠난 뒤 활동을 멈춘다. 세계의 남은 시간은 계속 줄어든다.</p>
    <p><b>원주민 조직</b> · 친해진 원주민끼리 모임을 만들고 우두머리를 뽑는다. 인원이 모이면 가까운 보스를 함께 사냥하며, 위험하면 후퇴한다. 원주민을 선택하면 소속과 우두머리 여부를 볼 수 있다. 조직 기능이 켜진 세계에서 활동하며 플레이어 길드와는 별개다.</p>
    <p><b>함께 사냥하기</b> · 원주민과 같은 몬스터를 함께 처치하면 친밀도가 오른다. 근처에서 구경만 해서는 오르지 않으며, 한 번의 처치는 한 번만 반영된다. 사냥터 안에서 함께 잡은 처치는 원주민 창의 「함께 잡은 몬스터」 수에만 들어가고, 친밀도는 사냥터 밖에서 함께 잡을 때 오른다.</p>`);
  h += expeditionHelp();
  h += inviteSec();
  h += '</details><details class="ux-details" id="help-device"><summary>보기 편하게 바꾸고 싶다 · 글자·설치</summary>' + sec('화면', readabilityControls());
  // Q276 — 새 소식·웹진은 메뉴 › 시스템 › 소식, 소리·알림은 메뉴 › 시스템 › 설정 한 곳에 있다(도움말에 두 벌을 두지 않는다)

  // 자동 안내를 미뤘어도 지원되는 설치 기회가 남으면 여기서 직접 연다.
  const mode = installMode();
  h += lore('설치 안내', muted('설치 안내에서 [추가]를 누르면 바탕화면이나 홈 화면에 바로가기를 만든다. [나중에]로 미루거나 [다시 묻지 않기]로 안내를 끌 수 있다. 지원하는 브라우저에서만 설치할 수 있다.'));
  if (mode === 'button') {
    h += sec('홈 화면', `<div class="item"><span class="nm">바탕화면에서 바로 연다<br>
      <span class="qt">주소창 없이 앱처럼 열린다</span></span>
      <button onclick="act.install()">추가</button></div>`);
  } else if (mode === 'ios') {
    // 아이폰에는 누를 버튼이 없다(브라우저가 안 준다). 없는 버튼을 그려두면 그게 거짓말이다.
    h += sec('홈 화면', muted(`
      아래 <b>공유</b> 버튼<span class="qt">(네모에 화살표)</span> → <b>홈 화면에 추가</b>.<br>
      그러면 주소창 없이 앱처럼 열린다.`));
  }

  // Q276 — 여는 곳은 [행사] › 시련의 탑(전에는 「하단 메뉴 → 랭킹」·마을 게시판이라 적혀 있었다). 규칙 전문은 [자세히] 안에
  h += '</details><details class="ux-details" id="help-events"><summary>큰 도전에 나서고 싶다 · 시련의 탑·공성전</summary><div class="ux-actions"><button onclick="act.openPanel(\'tower\')">탑 도전 살펴보기</button><button onclick="act.openPanel(\'siege\')">공성전 살펴보기</button></div>';
  h += sec('시련의 탑', fold('[행사] › 시련의 탑 — 정식 마을에서 「도전 시작」',
    `<small>탑 앞 안내인을 눌러도 열린다. 전초지에서는 시작할 수 없다.<br>
    사람은 입장 레벨 제한이 없고 첫 층 권장 레벨은 탑 화면의 현재 설정으로 확인한다. 입장료는 <b>은화 1,000,000</b>이다 — 가방이 모자라면 창고에서 모자란 몫을 쓴다. 층을 통과하면 다음 층 도전 또는 보상 받고 귀환을 선택한다. 탑 화면에 뜨는 남은 초 안에 고르지 않으면 자동으로 다음 층에 도전한다(마지막 층이면 귀환). 다른 사람과 전투가 섞이지 않으며 탑 안에서는 PK가 되지 않는다.<br>
    <b>탑 안에서는 경험치·은화·드롭이 없다.</b> 층을 통과하면 <b>층 보상</b>(층마다 강화석 — 높은 층일수록 많다, 10층마다 축복받은 강화석, 50층부터 10층마다 생명의 돌)을 보관했다가 귀환할 때 받는다. 층 보상은 <b>계정마다 그 주에 처음 오른 층만</b> 준다(월요일 0시, 한국 시간에 새로). 수치는 탑 화면에 나온다.<br>
    높은 층일수록 적이 단단해지고, 더 올라가면 빨라지고, 사람에게 받는 피해를 줄이고, 때리면 기절을 건다. 층을 통과하면 다음 층의 위험과 보상을 보고 고른다. 적의 얼굴(종류)은 매주 바뀌고 수치는 같다.<br>
    보상은 귀환할 때 받는다. 사망·시간 초과·도전 포기 시 탑에서 얻은 보상만 잃고 기존 장비와 은화는 보존한다. 입장료와 사용한 물약은 돌아오지 않는다.<br>
    가방에 못 담은 보상은 마을에서 정리한 뒤 다시 수령한다. 미수령 보상이 있으면 새 도전은 시작할 수 없다.<br>
    <b>이번 주 순위</b>는 한 번의 도전에서 오른 최고 층, 같은 층이면 1층부터 걸린 시간이 짧은 순이다. 월요일 0시에 <b>사람 1~3위</b>에게 축복받은 강화석·강화석을 계정 창고로 보낸다(원주민은 순위에만 오른다). 현재 세계·역대 최고 층도 같은 화면에서 본다.</small>`));
  // UNI-Q186 — 수치(비용·시간·보상·건물 수)는 콘솔 값이라 여기 적지 않는다. [행사] › 공성전 칸의 규칙 줄이 서버 값을 그대로 보인다(Q276 — 전에는 길드 창 탭).
  h += sec('공성전', fold('[행사] › 공성전 — 방어탑 둘 → 성문 → 본진',
    '<b>열린 길 하나</b>의 적 방어탑 둘(바깥 → 안쪽)을 무너뜨리면 <b>성문</b>, 성문이 무너지면 <b>본진</b>을 부술 수 있다. 서 있는 적 성문은 통행을 막는다. 본진이 무너진 편은 대패한다.')
    + lore('참전·회복·승패', `<b>참전</b> — 길드장이 다른 길드(길드원이 접속해 있어야 한다)나 원주민회에 선전포고한다. 비용은 길드 금고에서 나가고, 공성전이 무효가 되면 돌려받는다. 원주민회도 스스로 사람 길드에 선포한다. 전장이 하나라 한 번에 한 판만 열린다.<br>
      준비 시간에 <b>참전 신청</b>하면 시작할 때 접속해 있는 사람이 바다 위 전장으로 옮겨지고, 진행 중에도 같은 탭에서 들어간다. 사람이 우선이며 빈 자리는 NPC 가 길 밀기·수비·목표 공략을 맡는다. NPC 도 체력이 줄면 본진에서 회복하고 돌아온다.<br>
      <b>전투·회복</b> — 전력이 평준화되고 스킬 없이 평타로 싸운다. 물약 대신 우리 본진 안에서 체력이 찬다. 쓰러져도 아무것도 떨구지 않고 범죄·성향 변화도 없다. 잠시 뒤 우리 본진에서 다시 선다. 귀환 주문서 대신 탭의 「전장에서 나가기」를 쓴다. 나가거나 판이 끝나면 들어온 자리와 체력 비율로 돌아간다.<br>
      <b>승패</b> — 본진이 무너지면 대패, 시간이 다 되면 무너뜨린 구조물이 적은 편이 패배한다. 목표 격차로 대패시키는 설정이 켜져 있으면 시간 종료에도 대패가 될 수 있다. 무너뜨린 수가 같으면 무승부(보상·벌 없음). 이긴 편 길드 금고에는 왕도 금고에서 은화 보상이 들어오며 금고가 모자라면 있는 만큼 받는다. 진 편은 레벨이 남은 길드 건물에 피해를 받는다.<br>
      비용·시간·인원·보상·건물 피해 수치는 [행사] › 공성전 칸의 규칙 줄(현재 운영 설정)을 확인한다. 이미 열린 판은 선포 당시 설정을 따르며 확정 보상과 건물 결과는 종료 결과에 나온다.`)
    + siegeFieldHelp());
  // Q276 — 계정 연결·캐릭터 선택 버튼은 메뉴 › 시스템 › 계정 한 곳에 있다(도움말에 두 벌을 두지 않는다)
  h += '</details><details class="ux-details" id="help-account"><summary>기록을 보관하고 싶다 · 계정·만든 곳</summary><button onclick="act.openPanel(\'account\')">계정 보호 상태 살펴보기</button>';
  h += sec('계정', `${typeof guestHelpLine === 'function' ? guestHelpLine() : ''}`
    + muted('다른 기기에서 이어 하려면 <b>메뉴 › 시스템 › 계정</b>에서 Google·네이버를 연결한다. 캐릭터 선택도 거기서 한다.'));
  // R146(레드팀 C7, 결정 A) — 그림 출처를 밝힌다. 첫 화면 아래 줄(index.html .ai-credit)과 같은 뜻
  h += lore('그림 · 만든 곳', `유니지는 <b>FLOWLABS</b>가 만든다.<br>
    첫 화면 대표 그림·캐릭터 원화와 일부 도트 그림(캐릭터·몬스터·NPC)은 <b>AI 이미지 생성 도구로 만들었다</b>.`);
  return h + '</details>';
}
